import { React, useState, useEffect, useRef } from "react";
import Header from "../../../Common/header";
import Footer from "../../../Common/footer";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { API } from "../../../Common/lib/api";
import { Storage } from "../../../Common/lib/storage";
import { getUserSession } from "../../../Common/lib/Session";
import { isProjectOwnedByUser } from "../../../Common/lib/projectOwnership";
import SimpleReactValidator from "simple-react-validator";
import ConfirmSaveModal from "../Modals/confirmSaveModal";
import useDocumentTitle from "../../../Common/useDocumentTitle";
import { s3Upload } from "../../../Common/lib/Session";
export default function AddFile() {
  const [initialProject, setInitialProject] = useState();
  const [project, setProject] = useState();
  const [attachmentKeys, setAttachmentKeys] = useState([]);
  const [fileSizes, setFileSizes] = useState([]);
  let history = useHistory();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const projectId = query.get("projectID");
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
const [fileDescriptions, setFileDescriptions] = useState([]);
const [uploadProgress, setUploadProgress] = useState({
  loaded: 0,
  total: 100,
});
const [projectUploadFail, setProjectUploadFail] = useState(false);
const [isDragging, setIsDragging] = useState(false);
const [descriptionErrors, setDescriptionErrors] = useState([]);


  useDocumentTitle("Add Files");

  const [modalAction, setModalAction] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      try {
        const projectQuery = await API.projects.getById(projectId);
        const project = projectQuery.data.getProject;
        
        if (!project) {
          history.push("/");
          return;
        }
        
        // Check if user is the publisher of this project or is staff
        const user = await getUserSession();
        const isPublisher = isProjectOwnedByUser(project, user);
        const isStaff = user.is_staff === true || user.is_staff === "true";
        if (!isPublisher && !isStaff) {
          history.push("/");
          return;
        }

        //if the project is locked, return to the profile page.
        if (project.locked) {
          history.push("/profile?tab=My+Contributions");
          return;
        }

        //if the user is locked from editing any projects, return to the profile page.
        if (user?.edit_locked === "true"){
          history.push("/profile?tab=My+Contributions");
          return;
        }

        // Update the attachments state with the fetched data
        if (project.attachmentKeys) {
          setAttachments(JSON.parse(project.attachmentKeys));
        }
        if (project.fileSizes) {
          setFileSizes(JSON.parse(project.fileSizes));
        }

        setProject(project);
        setInitialProject(project);
      } catch (error) {
        console.error('Error fetching project:', error);
        history.push("/");
      }
    };

    fetchData();
  }, []);
  
  // Used to create a 19 digit ID to append to PK's.
  function flakeID() {
    const flakeID = new FlakeID();
    return intformat(flakeID.next(), "dec");
  }

  async function handleUploadFile() {
    let existingAttachments = project.attachmentKeys ? JSON.parse(project.attachmentKeys) : [];
    let newFileSizes = [...fileSizes];

    if (selectedFiles.length > 0) {
        const uploadPromises = selectedFiles.map(async (file, index) => {
            try {
                const fileId = await s3Upload(file, setUploadProgress, setProjectUploadFail);
                newFileSizes.push(getFileSizes(file));
                return {
                    key: fileId,
                    description: fileDescriptions[index] || ''
                };
            } catch (error) {
                setProjectUploadFail(true);
                console.error("Error uploading file: ", error);
            }
        });

        const newAttachments = await Promise.all(uploadPromises);
        newAttachments.forEach(newAttachment => {
            if (!existingAttachments.some(existing => existing.key === newAttachment.key)) {
                existingAttachments.push(newAttachment);
            }
        });
    }
    setSelectedFiles([]);
    return { attachments: existingAttachments, fileSizes: newFileSizes };
}

  const handleDragEnter = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
  };

  const handleDragLeave = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
  };

  const handleDragOver = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
  };

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const newFiles = Array.from(e.dataTransfer.files);
    setSelectedFiles(prevFiles => [...prevFiles, ...newFiles]);
};
  const fileInputRef = useRef(null);
  const handleFileInputClick = () => {
    fileInputRef.current.click();
  };
  // Function to get file sizes
  function getFileSizes(file) {
    const bytes = file.size;
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
  }

  
  function handleDescriptionChange(index, value) {
    const newDescriptions = [...fileDescriptions];
    newDescriptions[index] = value;
    setFileDescriptions(newDescriptions);

    const newErrors = [...descriptionErrors];
    newErrors[index] = value.length > 100 ? "Description must be less than 100 characters" : "";
    setDescriptionErrors(newErrors);
  }

  /**
   * Will determine if any changes were made to the project. If they were, an update Administration item will be created
   * and the edits made to the project will be saved.
   * @param {*} event
   */
  const handleSubmit = async () => {
    // Check if user is the publisher of the project before updating project
    const user = await getUserSession();
    if ("publisher-" + user.username) {
      try {
        if (simpleValidator.current.allValid()) {
          const updatedFields = getUpdatedFields();
          const uploadResults = await handleUploadFile();
          const newAttachments = uploadResults.attachments;
          const newFileSizes = uploadResults.fileSizes;

          //check if anything was even changed before submiting.
          if (updatedFields.length) {
            await API.projects.update({
              id: projectId,
              userID: user.username,
              publishStatus: project.publishStatus,
              attachmentKeys: JSON.stringify(newAttachments),
              fileSizes: JSON.stringify(newFileSizes),
            });
          }
          
          setTimeout(() => history.push("/profile?tab=My+Contributions"), 1000);
        } else {
          simpleValidator.current.showMessages();
          window.scrollTo(0, 0);
          // rerender to show messages for the first time
          forceUpdate(1);
        }
      } catch (e) {
        //console.log(e);
        console.error("Error in handleSubmit:", e);
      }
    } else {
      // console.log("Error: Project was not saved to the database.");
    }
  };
  
  const DisplayAttachments = ({ attachmentKeys, onAttachmentSelect }) => {
    const extractFilename = (path) => {
      return path.split('/').pop();
    };
    
    const handleCheckboxChange = (key, isChecked) => {
      onAttachmentSelect(key, isChecked);
    };
  
    return (
      <div>
        {attachmentKeys.map((attachment, index) => (
          <div key={index} className="flex items-center bg-white justify-start shadow overflow-hidden rounded-lg p-4 my-2">
            <div className="flex-grow">
              <div className="font-semibold">{extractFilename(attachment.key)}</div>
              <div className="text-sm text-gray-600">{attachment.description}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };


  /**
   * Will compare all editable fields current and original states to determine which ones have been changed.
   *
   * @returns The fields which have been updated.
   */
  function getUpdatedFields() {
    let updatedFields = [];

    const fieldsToCompare = [
        "attachmentKeys",
        "fileSizes",
    ];

    fieldsToCompare.forEach((field) => {
        if (JSON.stringify(project[field]) !== JSON.stringify(initialProject[field])) {
            updatedFields.push(field);
        }
    });

    const jsonFieldsToCompare = [
        ["attachmentKeys", attachmentKeys],
        ["fileSizes", fileSizes],
    ];

    jsonFieldsToCompare.forEach((field) => {
        if (JSON.stringify(initialProject[field[0]]) !== JSON.stringify(field[1])) {
            updatedFields.push(field[0]);
        }
    });

    return updatedFields;
}



  /**
   * Handles input field changes.
   * @param {*} field Name of userInfo property to change
   * @param {*} value Value from input field
   */
  function handleChange(field, value) {
    setProject((prevState) => ({
      ...prevState,
      [field]: value.trim(),
    }));
  }


  function removeFileAtIndex(index) {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);

    const newDescriptions = fileDescriptions.filter((_, i) => i !== index);
    setFileDescriptions(newDescriptions);
}

  function handleResubmitClick() {
    setProject((prevState) => ({
      ...prevState,
      publishStatus: "under review",
    }));
    setOpenConfirmModal(true);
    setModalAction('resubmit'); 
  }

  return (
    <>
      <Header />
      {project ? (
        <>
        <div className="lg:relative mb-24 mt-12 bg-white dark:bg-gray-900">
          <div className="relative max-w-2xl msm:max-w-lg overflow-hidden m-auto shadow-lg border bg-gray-100 dark:bg-gray-800 dark:border-gray-700">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-center font-extrabold text-gray-900 sm:text-xl sm:tracking-tight lg:text-3xl py-6 border-b-2 dark:border-gray-700 dark:text-white">
                Add File(s) to Project - {project.title}
              </h1>
              <section className="pt-4">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <form className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col items-center justify-center my-10">
                    <div
                      onClick={handleFileInputClick}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      className={`w-full p-6 border-2 border-dashed ${isDragging ? 'bg-gray-100 dark:bg-gray-700 border-blue-500' : 'border-gray-300 dark:border-gray-600'} rounded-md cursor-pointer`}
                    >
                      <p className="text-center text-gray-600">
                        {isDragging ? 'Drop the files here ...' : 'Drag and drop files here or click to upload'}
                      </p>
                    </div>
                    <input 
                      ref={fileInputRef}
                      type="file" 
                      multiple 
                      onChange={(e) => {
                        const newFiles = Array.from(e.target.files);
                        setSelectedFiles(prevFiles => [...prevFiles, ...newFiles]);
                    }}
                      className="hidden"
                    />
                        {selectedFiles.map((file, index) => (
                            <div key={index} className="mt-4 w-full max-w-2xl bg-white dark:bg-gray-700 shadow overflow-hidden rounded-lg p-4 flex justify-between items-center">
                                <span className="text-sm font-medium text-gray-900">{file.name} - {getFileSizes(file)}</span>
                                <input
                                  type="text"
                                  placeholder="Description"
                                  value={fileDescriptions[index] || ''}
                                  onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                  className={`mt-1 py-2 px-3 block w-3/5 shadow-sm outline-none focus:ring-1 border ${descriptionErrors[index] ? 'border-red-500' : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'} rounded-md`}
                                />
                                {descriptionErrors[index] && <div className="text-red-500 text-sm">{descriptionErrors[index]}</div>}
                                <button
                                    onClick={() => removeFileAtIndex(index)}
                                    className="ml-4 bg-red-100 rounded-full p-1 hover:bg-red-200"
                                >
                                    <svg className="h-4 w-4 stroke-current text-red-600" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L7 7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M1 7L7 1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="my-6">
                      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Attachment List:</h2>
                      <DisplayAttachments attachmentKeys={JSON.parse(project.attachmentKeys)} />
                    </div>
                    <div className="flex items-center justify-center my-10">
                      <input
                        onClick={() => {
                          setOpenConfirmModal(true);
                          setModalAction(initialProject?.publishStatus === 'rejected' ? 'saveForNow' : 'submit');
                        }}
                        data-cy="submit"
                        type="button"
                        value={initialProject?.publishStatus === 'rejected' ? "Save and Exit" : "Add Files"}
                        className="bg-blue-600 py-3 px-5 hover:bg-blue-500 cursor-pointer text-white sm:text-base text-sm font-medium rounded-md"
                      />

                      {initialProject?.publishStatus === 'rejected' && (
                        <input
                          onClick={handleResubmitClick}
                          data-cy="resubmit"
                          type="button"
                          value="Save and Resubmit"
                          className="bg-blue-600 py-3 px-5 hover:bg-blue-500 cursor-pointer text-white sm:text-base text-sm font-medium rounded-md ml-4" 
                        />
                      )}
                    </div>
                  </form>
                </div>
              </section>
            </div>
          </div>
        </div>
        <ConfirmSaveModal setOpenConfirmModal={setOpenConfirmModal} openConfirmModal={openConfirmModal} handleSubmit={handleSubmit} action={modalAction} />
        </>
      ) : (
        <p></p>
      )}
      <Footer />
    </>
  );
}